export default __webpack_public_path__ + "static/media/fastapi.cf57214f.svg";